// Resume-cursor bookkeeping for the dial-finish migration, which reads every
// reference brand by brand and can stop at a soft deadline.
//
// Pure, and its own module, because getting it wrong SKIPS DATA SILENTLY: the
// run reports success either way, and the refs it never looked at simply stay
// unmigrated. That is not a failure anyone would notice from the UI.
//
// The rule: a dry run and a write keep SEPARATE cursors. A dry run that stops
// at the deadline has only PREVIEWED the brands it covered; handing its cursor
// to the write would start the write after them.

export interface MigrationCursors {
  /** Where the next dry run resumes, or null to start from the first brand. */
  dry: string | null;
  /** Where the next write resumes, or null to start from the first brand. */
  wet: string | null;
}

export const NO_CURSORS: MigrationCursors = { dry: null, wet: null };

/** The cursor a run of this mode should send. */
export function cursorForRun(cursors: MigrationCursors, dryRun: boolean): string | null {
  return dryRun ? cursors.dry : cursors.wet;
}

/** The cursors after a run returns. Only the mode that ran advances. */
export function advanceCursors(
  cursors: MigrationCursors,
  run: { dryRun: boolean; complete: boolean; lastBrandId: string | null },
): MigrationCursors {
  const next = run.complete ? null : run.lastBrandId;
  return run.dryRun ? { ...cursors, dry: next } : { ...cursors, wet: next };
}
